<template>
    <div id="app">
        <div v-if="showBanner" class="bg-yellow-300 text-center p-2">
            Tired of scrolling? Sign up <a href="https://www.eacts.org/sign-up/" target="_blank" class="underline text-primary">here</a> to receive updates on the latest publications!
        </div>
        <header>
            <div class="container py-4">
                <div class="row items-center">
                    <div class="md:col-1/2 md:mb-3 lg:mb-4">
                        <inertia-link class="d-inline-block inline-block" href="/">
                            <img alt="MMCTS logo" class="max-h-full site_logo" src="/images/EACTS_MMCTS_Primary-Navy.png">
                        </inertia-link>
                    </div>
                    <div class="hidden md:block md:col-1/2">
                        <div class="row items-center">
                            <div class="col">
                                <SearchBox/>
                            </div>
                            <div class="col-auto">
                                <a class="ml-auto" href="http://www.eacts.org/"
                                   rel="noopener noreferrer"
                                   target="_blank">
                                    <img alt="EACTS logo" class="h-20 w-60 eactslogo" src="/images/EACTS_Logos-FinalRGB_Primary-Navy.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-hearted" id="navigation">
                <div class="flex justify-between items-center text-white leading-none md:hidden">
                    <button aria-label="toggle nav" class="w-12 h-12" @click.prevent="toggleNav">
                        <svg class="inline-block w-6 h-6" fill="none" stroke="currentColor" stroke-linecap="round"
                             stroke-linejoin="round"
                             stroke-width="2" viewBox="0 0 24 24">
                            <path d="M4 6h16M4 12h16M4 18h16"></path>
                        </svg>
                    </button>
                    <button aria-label="toggle search" class="w-12 h-12" @click.prevent="toggleSearch">
                        <font-awesome-icon :icon="searchVisible ? 'times': 'search'"/>
                    </button>
                </div>
                <div
                    :class="{hidden: !navOpen}"
                    class="text-white py-3 px-4 border-t border-t-white mx-auto md:block w-full md:max-w-screen-md md:py-2 md:border-t-0 lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl">
                    <nav class="lg:flex">
                        <ul class="text-sm uppercase space-y-4 md:inline-flex md:space-y-0 md:space-x-2" >
                            <li v-for="navCategory in $page.props.navCategories"
                                class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link
                                    :class="{'border-primary-light': $page.url.split('?')[0] === `/categories/${navCategory.slug}`}"
                                    :href="`/categories/${navCategory.slug}`"
                                    class="pt-2 border-b-4 border-transparent"
                                    v-text="navCategory.name"/>
                            </li>
                        </ul>
                       <ul
                            class="text-sm uppercase space-y-4 md:inline-flex md:space-y-0 md:space-x-2 pt-1 second-menu-ul">
                            <li class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link href="/about" class="pt-2 border-b-4 border-transparent"
                                    :class="{'border-primary-light': $page.url.split('?')[0] === `/about`}">About</inertia-link>
                            </li>
                            <!-- <li class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link href="/aims-and-scope" class="pt-2 border-b-4 border-transparent"
                                :class="{'border-primary-light': $page.url.split('?')[0] === `/aims-and-scope`}">Aims & Scope</inertia-link>
                            </li> -->
                            <li class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link href="/author-guidelines" class="pt-2 border-b-4 border-transparent"
                                    :class="{'border-primary-light': $page.url.split('?')[0] === `/author-guidelines`}">Author
                                    Guidelines</inertia-link>
                            </li>
                        
                            <li class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link href="/mmcts-submission-form" class="pt-2 border-b-4 border-transparent"
                                    :class="{'border-primary-light': $page.url.split('?')[0] === `/mmcts-submission-form`}">Submit</inertia-link>
                            </li>
                                <li class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link href="/residents-corner" class="pt-2 border-b-4 border-transparent"
                                    :class="{'border-primary-light': $page.url.split('?')[0] === `/residents-corner`}">Residents'
                                    Corner</inertia-link>
                            </li>
                            <li class="pr-3 md:border-r md:border-white last:border-r-0">
                                <inertia-link href="/contact" class="pt-2 border-b-4 border-transparent"
                                    :class="{'border-primary-light': $page.url.split('?')[0] === `/contact`}">Contact</inertia-link>
                            </li>

                        </ul>

                    </nav>
                </div>
                <SearchBox ref="mobileSearch" :class="{hidden: !searchVisible}" class="md:hidden"/>
            </div>
        </header>
        <main>
            <slot></slot>
            <div class="lust-blue py-8">
                <div class="container">
                    <h2 class="text-white text-center text-xl font-semibold uppercase">More From EACTS</h2>

                    <div class="row">
                        <div v-for="externalLink in $page.props.externalLinks"
                             class="col-full sm:col-1/2 lg:col-1/4 mt-8">
                            <a :href="externalLink.link" class="block bg-white h-full mx-auto max-w-sm sm:max-w-none"
                               rel="noopener"
                               target="_blank">
                                <div class="bg-white">
                                    <img
                                        :alt="`${externalLink.title} image`"
                                        :src="`/media/${externalLink.upload.uuid}`"
                                        class="w-full">
                                    <div>
                                        <p class="text-lg px-3 py-4">{{ externalLink.title }}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <footer class="bg_navy_blue  pt-4 pb-8" id="footer">
            <div class="container text-white">
                <div class="row">
                    <div class="sm:col-1/2 lg:col-1/4 mt-8">
                        <h3 class="mb-3">MMCTS</h3>
                        <nav>
    				<ul class="text-sm text-grey-lighter space-y-2">
                                <li>
                                    <inertia-link href="/about">About</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/residents-corner">Residents' Corner</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/editoral-board">Editorial Board</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/author-guidelines">Author Guidelines</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/mmcts-submission-form">MMCTS Submission Form</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/author-directory">Author Directory</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/privacy-policy">Privacy Policy</inertia-link>
                                </li>
                                <li>
                                    <inertia-link href="/contact">Contact</inertia-link>
                                </li>
                      
                                 <li>
                                    <inertia-link href="/residents-tutorial-competition">Residents' Tutorial
                                        Competition</inertia-link>
                                </li>
                                
                                
                            </ul>
                        </nav>
                    </div>
                    <div class="sm:col-1/2 lg:col-1/4 mt-8">
                        <img alt="Winner Best in class 2017" class="max-h-48" src="/images/award.png"/>
                    </div>
                    <div class="sm:col-1/2 lg:col-1/4 mt-8">
                        <h3 class="mb-4">Connect with us</h3>
                        <ul class="inline-flex space-x-6 mb-4">
                            <li>
                                <a href="https://www.youtube.com/user/EACTS" rel="noopener" target="_blank"
                                   title="MMCTS on Youtube">
                                    <font-awesome-icon :icon="['fab', 'youtube-square']" size="2x"/>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/EuropeanAssociationCardioThoracicSurgery/" rel="noopener" target="_blank"
                                   title="MMCTS on Facebook">
                                    <font-awesome-icon :icon="['fab', 'facebook-square']" size="2x"/>
                                </a>
                            </li>
                           
                            <li>
                                <a href="https://x.com/EACTS" rel="noopener" target="_blank"
                                   title="MMCTS on Twitter" style="margin: 2px 0 0 0; display: inline-block; vertical-align: top; border-radius: 3px; overflow: hidden;">
                                   <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0,0,256,256"
                                            style="fill:#FFFFFF;">
                                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,256v-256h256v256z" id="bgRectangle"></path></g><g fill="#00285f" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(10.66667,10.66667)"><path d="M4.4043,3c-0.647,0 -1.02625,0.72877 -0.65625,1.25977l5.98828,8.55859l-6.01172,7.02734c-0.389,0.454 -0.06675,1.1543 0.53125,1.1543h0.66406c0.293,0 0.57172,-0.12856 0.76172,-0.35156l5.23828,-6.13672l3.94336,5.63477c0.375,0.534 0.98667,0.85352 1.63867,0.85352h3.33398c0.647,0 1.02625,-0.72781 0.65625,-1.25781l-6.31836,-9.04297l5.72656,-6.70898c0.332,-0.39 0.05497,-0.99023 -0.45703,-0.99023h-0.8457c-0.292,0 -0.56977,0.12761 -0.75977,0.34961l-4.8418,5.66016l-3.60156,-5.1543c-0.374,-0.536 -0.98467,-0.85547 -1.63867,-0.85547z"></path></g></g>
                                            </svg>
                                   
                                </a>
                            </li>
                            
                            <li>
                                <a href="https://www.linkedin.com/company/european-association-for-cardio-thoracic-surgery"
                                   rel="noopener" target="_blank" title="MMCTS on LinkedIn">
                                    <font-awesome-icon :icon="['fab', 'linkedin']" size="2x"/>
                                </a>
                            </li>
                        </ul>
                        <h3>Indexed by PubMed</h3>
                        <p class="text-sm text-grey-lighter mt-2">Multimedia Manual of Cardio-Thoracic Surgery</p>
                        <p class="text-sm text-grey-lighter mt-2">
                            Online ISSN: 1813-9175
                        </p>
                    </div>
                    <div class="sm:col-1/2 lg:col-1/4 mt-8">
                         <a class="inline-block mb-4"
                           href="http://www.eacts.org/"
                           rel="noopener"
                           target="_blank"
                           title="EACTS Website">
                            <img alt="EACTS logo" src="/images/EACTS_Logos-FinalRGB_Primary-White.png">
                        </a>
                        <p class="text-grey-lighter">
                            Copyright &copy; {{ (new Date).getFullYear() }} EACTS
                        </p>
                        <p class="text-grey-lighter">
                            All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
        <button
            v-if="showBackToTop"
            class="fixed bottom-0 right-0 mb-16 mr-4 w-12 h-12 bg-grey-lightest border border-grey-light rounded"
            type="button"
            @click.prevent="backToTop">
            <font-awesome-icon
                class="text-grey-dark"
                icon="chevron-up"/>
        </button>
        <portal-target multiple name="modal"/>
    </div>
</template>

<script>

import SearchBox from "@app/Shared/Components/SearchBox";

export default {

    data() {
        return {
            navOpen: false,
            searchVisible: false,
            showBackToTop: false
        }
    },

    computed: {
        showBanner() {
            return this.$page.component === 'Home';
        }
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll);
    },

    components: {
        SearchBox
    },

    methods: {
        backToTop() {
            window.scrollTo(0, 0);
        },
        toggleNav() {
            this.searchVisible = false;
            this.navOpen = !this.navOpen;
        },
        toggleSearch() {
            this.navOpen = false;
            this.searchVisible = !this.searchVisible;
        },
        onScroll() {
            this.showBackToTop = (window.pageYOffset || document.documentElement.scrollTop) >= 50;
        },
    },

    watch: {
        '$page'() {
            this.navOpen = false;

            if (!this.$refs.mobileSearch.inputHasFocus() && this.$inertia.page.component === 'Search') {
                this.searchVisible = false;
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },
};

</script>
